import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { selectCurrentUserProfile } from '@libs/store';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'lib-ffd-notes-activate',
  standalone: true,
  imports: [TranslateModule, SvgIconComponent, QRCodeModule],
  templateUrl: './ffd-notes-activate.component.html',
  styleUrls: ['./ffd-notes-activate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FfdNotesActivateComponent {
  private readonly store = inject(Store);

  private readonly profile = this.store.selectSignal(selectCurrentUserProfile);

  protected readonly qrData = computed(() => `${window.location.origin}/mobile-notes/baa-activation/${this.profile()?.id ?? ''}`);
  protected readonly qrCodeSize = 200;
  protected readonly logoSize = 22;

  protected onSyncMyNotes(): void {
    window.location.reload();
  }
}
